export const environment = {
    production: false,
    apiUrl: 'https://staging.researchdecode.com/api',
    socketUrl: 'https://staging.researchdecode.com/api',
    appName: 'Research Decode (Staging)',
    bulkpe: 'https://api.bulkpe.in',
    razorpayKeyId: 'rzp_live_RNsqf8kl7CeXsn',
  
};